'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResponsiveEmbed = require('react-bootstrap/lib/ResponsiveEmbed');

var _ResponsiveEmbed2 = _interopRequireDefault(_ResponsiveEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResponsiveEmbed2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ResponsiveEmbed.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ResponsiveEmbed.js
 ** module chunks = 0
 **/